module.exports = __webpack_public_path__ + "united-nations.svg?71cca5969a48cf1d1d24defe334b35a5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/united-nations.svg
// module id = 332
// module chunks = 10